class OpSms extends HTMLElement {
  constructor() {
    super();
    this.templates = [];
    this.retailerId = this.dataset.retailerId;
    this.selectElement = this.querySelector('#op-sms-form-reason');
    this.freeTextTriggerId = 'free-text';
    this.smsTemplatesEndpoint = `/apps/indeks-retail-sms/proxy/sms/templates`;
    this.smsSendEndpoint = `/apps/indeks-retail-sms/proxy/sms/send`;
    this.fetchSmsTemplates();

    this.handleEventListeners();
  }

  handleEventListeners() {
    this.addEventListener('change', function(e) {
      if (e.target.closest('select#op-sms-form-reason')) {
        let templateTriggerId = e.target.value;
        if (templateTriggerId === this.freeTextTriggerId) {
          this.querySelector('#op-sms-form-body').value = '';
          return;
        }
        if (templateTriggerId) {
          let template = this.templates.find(template => template.triggerId === templateTriggerId);
          if (template) {
            this.querySelector('#op-sms-form-body').value = template.content;
          }
        }
      }
    });

    this.addEventListener('submit', function(e) {
      e.preventDefault();
      e.stopPropagation();
      let formData = new FormData(e.target);
      let data = Object.fromEntries(formData);

      data.phoneNumbers = data.phoneNumbers
        .split(',')
        .map(n => n.trim())
        .filter(Boolean);

      let originalContent = this.templates.find(template => template.triggerId === data.triggerId)?.content;
      if (data.triggerId === this.freeTextTriggerId || originalContent !== data.content) {
        delete data.triggerId;
      }
      this.querySelector('button[type="submit"]').classList.add('is-loading');
      fetch(this.smsSendEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
      })
      .then(response => response.json())
      .then(data => {
        if (data.status === 'success') {
          this.querySelector('.alert.bg-success-bg').classList.remove('hidden');
          this.querySelector('.alert.bg-error-bg').classList.add('hidden');
        } else {
          this.querySelector('.alert.bg-error-bg').classList.remove('hidden');
          this.querySelector('.alert.bg-success-bg').classList.add('hidden');
        }
        setTimeout(() => {
          this.querySelector('button[type="submit"]').classList.remove('is-loading');
        }, 1000);
      })
      .catch(error => {
        console.error('Error sending SMS:', error);
        this.querySelector('.alert.bg-error-bg').classList.remove('hidden');
        this.querySelector('.alert.bg-success-bg').classList.add('hidden');
        this.querySelector('button[type="submit"]').classList.remove('is-loading');
      });
    });
  }

  async fetchSmsTemplates() {
    this.classList.add('op-loading');
    const response = await fetch(this.smsTemplatesEndpoint);
    const templates = await response.json();
    this.classList.remove('op-loading');
    if (templates && templates.length) {
      this.templates = templates;
      this.renderSmsTemplates();
    } else {
      alert('No SMS templates found');
    }
  }

  renderSmsTemplates() {
    // sort templates by name
    this.templates.sort((a, b) => a.name.localeCompare(b.name));
    this.templates.forEach(template => {
      if (template.name && template.triggerId) {
        this.selectElement.innerHTML += `<option value="${template.triggerId}">${template.name}</option>`;
      }
    });
  }
}

customElements.define('op-sms', OpSms);